module.exports = __webpack_public_path__ + "static/img/rank_73.0a7080e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_73.png
// module id = yyJL
// module chunks = 0